var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showed && _vm.isAllowedToShow)?_c('div',{staticClass:"asset-replace-container",style:(_vm.containerStyle)},[_vm._m(0),_c('div',{staticClass:"asset-replace-hint"},[_vm._v("Double-click to replace image")])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asset-replace-btn"},[_c('i',{staticClass:"fa fa-upload"})])
}]

export { render, staticRenderFns }